import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
import { Plus, Minus } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQSection() {
  const faqs = [{
    q: '¿Sirve si nunca hice meditación ni terapia de sonido?',
    a: 'Sí. De hecho, está diseñado para eso. No necesitás experiencia previa, creencias especiales ni habilidades particulares. El sonido actúa sobre tu fisiología de forma automática e involuntaria. Si tenés oídos, funciona.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Inmediatamente después del pago recibís un correo en tu casilla con el acceso a todos los tomos y bonos en formato PDF. Podés leerlos en el teléfono, tablet o computadora. Sin apps adicionales. Sin contraseñas complicadas.'
  }, {
    q: '¿Funciona para ansiedad diagnosticada o solo para estrés común?',
    a: 'Los protocolos funcionan para ambos casos. Son herramientas complementarias, no reemplazos de tratamiento médico. Muchas personas con diagnóstico de ansiedad, insomnio o dolor crónico los usan junto a su tratamiento habitual para potenciar los resultados.'
  }, {
    q: '¿Necesito auriculares especiales o equipos costosos?',
    a: 'No. Los auriculares básicos que ya tenés funcionan perfectamente para la mayoría de los protocolos. Los bonos incluyen alternativas con el parlante del teléfono, instrumentos de cocina y la voz propia. El sistema está diseñado para el presupuesto argentino real.'
  }, {
    q: '¿Tiene garantía real?',
    a: '7 días de garantía total. Si abrís los tomos, los aplicás durante una semana y no es lo que esperabas, escribís a soporte.tumanualdigital@gmail.com y te devolvemos el 100% sin preguntas. Menos del 1% de los compradores pide la devolución.'
  }, {
    q: '¿Puedo usarlo con solo 5 minutos por día?',
    a: 'Sí. El sistema tiene protocolos de emergencia de 5 minutos para situaciones agudas y micro-dosis de 60 segundos para integrar en cualquier día ocupado. El plan base requiere 20-35 minutos diarios, pero hay versiones express para cada protocolo.'
  }];
  return <section className="py-8 md:py-20 px-4 max-w-3xl mx-auto" data-id="element-115">
      <FadeIn data-id="element-116">
        <h2 className="text-2xl md:text-5xl font-black text-[#1f1b16] text-center mb-6 md:mb-14 flex items-center justify-center gap-3 md:gap-4" data-id="element-117">
          <span className="text-3xl md:text-5xl drop-shadow-[0_0_15px_rgba(124,58,237,0.2)]" data-id="element-118">
            ❓
          </span>{' '}
          PREGUNTAS FRECUENTES
        </h2>

        <div className="space-y-2.5 md:space-y-4" data-id="element-119">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.q} answer={faq.a} data-id="element-120" />)}
        </div>
      </FadeIn>
    </section>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <motion.div className={`border rounded-2xl overflow-hidden transition-colors duration-300 ${isOpen ? 'bg-[#faf7f2] border-[#7c3aed] shadow-[0_5px_15px_rgba(124,58,237,0.1)]' : 'bg-[#faf7f2] border-[#e7dfce] hover:border-[#7c3aed]/50 shadow-sm'}`} data-id="element-121">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full px-4 md:px-6 py-4 md:py-6 text-left flex justify-between items-center focus:outline-none gap-3" data-id="element-122">
        <span className={`font-black text-sm md:text-xl pr-2 md:pr-4 transition-colors ${isOpen ? 'text-[#5b21b6]' : 'text-[#1f1b16]'}`} data-id="element-123">
          {question}
        </span>
        <div className={`shrink-0 p-1.5 md:p-2 rounded-full transition-colors ${isOpen ? 'bg-[#7c3aed]/20 text-[#5b21b6]' : 'bg-[#f5efe4] text-[#6b6358]'}`} data-id="element-124">
          {isOpen ? <Minus className="w-4 h-4 md:w-5 md:h-5" data-id="element-125" /> : <Plus className="w-4 h-4 md:w-5 md:h-5" data-id="element-126" />}
        </div>
      </button>
      <AnimatePresence data-id="element-127">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} data-id="element-128">
            <div className="px-4 md:px-6 pb-4 md:pb-6 pt-1 md:pt-2" data-id="element-129">
              <p className="text-[#6b6358] leading-relaxed text-sm md:text-lg font-medium" data-id="element-130">
                {answer}
              </p>
            </div>
          </motion.div>}
      </AnimatePresence>
    </motion.div>;
}